import React from "react";

function VideoBubbleMessage({ src, bubbleSrc }) {
  const mainSrc = src ? "" + src : "";
  const pipSrc = bubbleSrc ? "" + bubbleSrc : "";
  const hasDistinctBubble =
    Boolean(mainSrc) && Boolean(pipSrc) && mainSrc !== pipSrc;

  // Only bubble url available → circular bubble video
  if (!hasDistinctBubble && (pipSrc || mainSrc)) {
    const circleSrc = pipSrc || mainSrc;
    return (
      <div className="video-bubble-circle-only">
        <video
          controls
          playsInline
          className="video-bubble-circle-only-video"
          src={circleSrc}
        >
          Your browser does not support the video tag.
        </video>
        <div className="video-bubble-label">bubble video</div>
      </div>
    );
  }

  // Main video + bubble video → bubble on video
  if (hasDistinctBubble) {
    return (
      <div className="video-bubble-message-wrap">
        <video
          controls
          playsInline
          className="video-bubble-message-main"
          src={mainSrc}
        >
          Your browser does not support the video tag.
        </video>
        <div className="video-bubble-message-pip">
          <video
            playsInline
            muted
            autoPlay
            loop
            className="video-bubble-message-pip-video"
            src={pipSrc}
          >
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="video-bubble-label video-bubble-label--overlay">
          bubble on video
        </div>
      </div>
    );
  }

  return <div className="video-bubble-fallback">bubble on video</div>;
}

export default VideoBubbleMessage;
